(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    (function(){
  // When clicking the inline link inside <summary>, navigate and do NOT toggle details
  document.addEventListener('click', function(e){
    var a = e.target.closest('a.drawer-parent-link[data-no-toggle]');
    if (!a) return;
    e.stopPropagation();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
